import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import DataContainer from '../../../Shared/DataContainer';
import DropdownButton from '../../../Shared/DropdownButton';
import TextInput from '../../../Shared/TextInput';
import LoadingButton from '../../../Shared/LoadingButton';
import Pagination from '../../../Shared/Pagination';
import Icon from '../../../Shared/Icon';
import { can } from '../../../utils';
import ReactToPrint from "react-to-print";
import axios from "axios";

const Show = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          reference: '',
          phone: ''
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value,
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          Inertia.post(route('proforma.to.order', data.id), values).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="purchase-detail">
               <Helmet>
                    <title>Cart Details</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Cart Details</span>
               </div>

                    <div className="w-full bg-white">
                         <div className="flex flex-col w-full p-8 text-gray-800 mt-2 pin-r pin-y text-sm">
                              <div className="flex w-full">
                                   <div className="w-1/2 px-3 py-3">
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 mr-2 text-gray-700">No. Receipt <span className="font-semibold float-right text-gray-500">{data.number}</span></div>
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 text-gray-700">No. Reference <span className="font-semibold float-right text-gray-500">{data.user?data.user:'-'}</span></div>
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 text-gray-700">No. MHD <span className="font-semibold float-right text-gray-500">{data.email}</span></div>
                                        {data.origin && <div className="font-semibold p-2 bg-gray-100 mt-2 text-gray-700">No. MHD <span className="font-semibold float-right text-gray-500">{data.origin}</span></div>}
                                   </div>
                                   <div className="w-1/2 px-3 py-3">
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 mr-2 text-gray-700">Quote <span className="font-semibold float-right text-gray-500">{data.proforma?'Yes':'No'}</span></div>
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 mr-2 text-gray-700">Sold <span className="font-semibold float-right text-gray-500">{data.sold?'Yes':'No'}</span></div>
                                        <div className="font-semibold p-2 bg-gray-100 mt-2 mr-2 text-gray-700">Date <span className="font-semibold float-right text-gray-500">{data.created}</span></div>
                                   </div>
                              </div>
                         </div>
                         <div className="w-full flex px-8 py-4 bg-white">
                              <table className="table-fixed w-full text-sm">
                                   <thead className="bg-gray-100">
                                        <tr>
                                             <th className="px-4 py-2">Product</th>
                                             <th className="px-4 py-2">Quantity</th>
                                             <th className="px-4 py-2">Reg Price</th>
                                             <th className="px-4 py-2">Price</th>
                                             <th className="px-4 py-2">Total</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {data.details.map(({name, code, quantity, currency, price, promotion, total},i) => {
                                             return <tr key={`item${i}`}>
                                                  <td className="border px-4 py-2">{name}<br /><span className="text-xs text-gray-500 italic">{code}</span></td>
                                                  <td className="border px-4 py-2 text-center">{quantity}</td>
                                                  <td className="border px-4 py-2 text-center">{currency} {price.toFixed(2)}</td>
                                                  <td className="border px-4 py-2 text-center">{currency} {promotion.toFixed(2)}</td>
                                                  <td className="border px-4 py-2 text-center">{currency} {total.toFixed(2)}</td>
                                             </tr>
                                        })}
                                   </tbody>
                                   <tfoot className="bg-gray-100 font-semibold text-lg">
                                        <tr>
                                             <td colSpan="4" className="px-4 py-2 text-right">Total</td>
                                             <td className="px-4 py-2 text-right">{data.currency} {data.amount}</td>
                                        </tr>
                                   </tfoot>
                              </table>
                         </div>
                         {can(auth.user, 'create-permission')?<div className="w-full border border-t px-8 py-4 bg-white">
                              <form onSubmit={handleSubmit}>
                                   <TextInput
                                         className="form-input rounded-md shadow-sm mt-4 block w-1/2"
                                         label="Reference No."
                                         name="reference"
                                         type="text"
                                         disable={false}
                                         readonly={false}
                                         errors={errors.reference}
                                         value={values.reference}
                                         onChange={handleChange}
                                   />
                                   <TextInput
                                         className="form-input rounded-md shadow-sm mt-4 block w-1/2"
                                         label="Phone No."
                                         name="phone"
                                         type="text"
                                         disable={false}
                                         readonly={false}
                                         errors={errors.phone}
                                         value={values.phone}
                                         onChange={handleChange}
                                   />
                                   <div className="flex items-center justify-end px-4 py-3 bg-gray-100 text-right sm:px-6 rounded-b">
                                        <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                             Convert To Order
                                        </LoadingButton>
                                   </div>
                              </form>
                         </div>:null}
                    </div>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Show.layout = page => <AdminLayout children={page} header={'Cart Details'} />;

export default Show;
